import { Modal, Upload } from "antd";
import styled from "styled-components";

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    padding: 0;
    overflow: visible;
  }
  .ant-modal-body {
    padding: 1.5rem;
    overflow: visible;
  }
`;

export const Panel = styled.div`
  background: #fafafa;
  border-radius: 12px;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
  font-size: 18px;
  font-weight: 500;
  color: #111;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0 0 1.25rem;
`;

export const ModeRow = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 1.5rem;
`;

export const ModeButton = styled.button`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 12px;
  text-align: left;
  border-radius: 8px;
  border: 1px solid ${(p) => (p.$active ? "#ff6b35" : "#e5e5e5")};
  background: ${(p) => (p.$active ? "#ff6b35" : "#fff")};
  color: ${(p) => (p.$active ? "#fff" : "#111")};
  cursor: pointer;
  font-family: inherit;

  .mode-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 500;
    font-size: 14px;
  }
  .mode-sub {
    font-size: 12px;
    color: ${(p) => (p.$active ? "rgba(255,255,255,0.85)" : "#888")};
  }
`;

export const FieldLabel = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 6px;
  color: #222;
`;

export const PriorityRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 4px;
`;

export const ChipButton = styled.button`
  flex: 1;
  padding: 8px 4px;
  border-radius: 6px;
  border: 1px solid ${(p) => (p.$active ? "#ff6b35" : "#e5e5e5")};
  background: ${(p) => (p.$active ? "#ff6b35" : "#fff")};
  color: ${(p) => (p.$active ? "#fff" : "#333")};
  cursor: pointer;
  font-size: 13px;
  font-family: inherit;
`;

export const SlaText = styled.p`
  font-size: 12px;
  color: #888;
  margin: 0 0 1rem;
  min-height: 16px;
`;

export const SubmitButton = styled.button`
  width: 100%;
  background: #ff6b35;
  color: #fff;
  border: none;
  height: 40px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const AvailabilityBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #e8f8ef;
  border-radius: 8px;
  padding: 8px 12px;
  margin-bottom: 1rem;
  font-size: 13px;
  color: #1a7f4b;

  span.dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #1a7f4b;
  }
`;

export const SlotRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 1rem;
`;

export const DoneWrap = styled.div`
  text-align: center;
  padding: 1.5rem 0;
`;

export const DoneTitle = styled.p`
  font-size: 16px;
  font-weight: 500;
  margin: 8px 0 2px;
`;

export const DoneMsg = styled.p`
  font-size: 13px;
  color: #666;
  margin: 0 0 1rem;
`;

export const StyledUpload = styled(Upload)`
  .ant-upload-select {
    width: 100% !important;
  }
`;
